import { render, staticRenderFns } from "./table-data-4.vue?vue&type=template&id=25d0668d&scoped=true"
import script from "./table-data-4.vue?vue&type=script&lang=js"
export * from "./table-data-4.vue?vue&type=script&lang=js"
import style0 from "./table-data-4.vue?vue&type=style&index=0&id=25d0668d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d0668d",
  null
  
)

export default component.exports